<script>
export default {
  name: 'Paginator',
  props: {
    page: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    rowsPerPage: {
      type: Number,
      default: 10,
    },
    rowsPerPageOptions: {
      type: Array,
      default: () => [10, 25, 50],
    },
  },
  data() {
    return {
      pageValue: null,
    }
  },
  methods: {
    setPage(mode) {
      let page = this.page
      switch (mode) {
        case 'increment':
          page += 1
          break
        case 'decrement':
          page -= 1
          break
        case 'first':
          page = 1
          break
        case 'last':
          page = this.totalPages
          break
        default:
          break
      }
      this.$emit('change-page', page)
    },
    setPageManual(value) {
      if (!value) return
      this.pageValue = null
      const page = parseInt(value)
      if (page <= 0) return
      if (page > this.totalPages) return
      this.$emit('change-page', page)
    },
    setRowsPerPage(value) {
      this.$emit('change-rows-per-page', value)
    },
  },
}
</script>

<template>
  <div class="pagination-wrapper">
    <div class="pagination-rpp-wrapper mr-3">
      <div class="mr-3">{{ $t('table__rows_per_page_text') }}</div>
      <div>
        <v-select
          :items="rowsPerPageOptions"
          :value="rowsPerPage"
          single-line
          dense
          @change="setRowsPerPage($event)" />
      </div>
    </div>
    <div class="pagination-page-wrapper">
      <v-btn
        :disabled="first"
        color="primary"
        small
        flat
        class="mx-0"
        @click="setPage('first')">
        <v-icon>first_page</v-icon>
      </v-btn>
      <v-btn
        :disabled="first"
        color="primary"
        small
        flat
        class="mx-0"
        @click="setPage('decrement')">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-text-field
        ref="paginationInput"
        v-model="pageValue"
        :placeholder="`${page} / ${totalPages}`"
        dont-fill-mask-blanks
        mask="######"
        class="pagination-input"
        @change="setPageManual($event)"
        @keypress.enter="setPageManual($event.target.value)"
      />
      <v-btn
        :disabled="last"
        color="primary"
        small
        flat
        class="mx-0"
        @click="setPage('increment')">
        <v-icon>chevron_right</v-icon>
      </v-btn>
      <v-btn
        :disabled="last"
        color="primary"
        small
        flat
        class="mx-0"
        @click="setPage('last')">
        <v-icon>last_page</v-icon>
      </v-btn>
    </div>
  </div>
</template>
